import { RiskMeasuresState } from '@types';

export const RISK_MEASURES_INITIAL_STATE: RiskMeasuresState = {
  shareClassName: null,
  benchmarkName: null,
  asOfDate: null,
  config: {
    isFundOlderThan10Yrs: null,
  },
  stdDev: [],
  sharpeRatio: [],
  statistics: [],
};
